"use client";

import { Navigation as UINavigation } from "@jesus-central-church/ui";
import { CinematicMenu } from "./cinematic-menu";
import {
  SbBlokData,
  storyblokEditable,
  StoryblokServerComponent,
} from "@storyblok/react/rsc";
import { SbWebsiteConfig } from "@storyblok/types/287435740670216/storyblok-components";


interface NavigationProperties {
  config: SbWebsiteConfig;
  locale: string;
}

export function Navigation({ config, locale }: NavigationProperties) {
  if (!config) {
    return null;
  }

  const { logo, header_cta_buttons, show_menu, menu_data, social_links } =
    config;

  return (
    <UINavigation
      locale={locale}
      logo={{
        filename: logo?.filename || undefined,
        alt: logo?.alt || undefined,
        width: logo?.width || undefined,
        height: logo?.height || undefined,
      }}
      ctaButtonsRenderer={
        header_cta_buttons && header_cta_buttons.length > 0 ? (
          <>
            {header_cta_buttons.map((cta) => (
              <StoryblokServerComponent key={cta._uid} blok={cta} />
            ))}
          </>
        ) : undefined
      }
      showMenu={show_menu}
      menuComponent={
        show_menu ? (
          <CinematicMenu menu_data={menu_data} social_links={social_links} />
        ) : undefined
      }
      {...storyblokEditable(config as SbBlokData)}
    />
  );
}
